import React, {useRef, useState} from 'react';
import styled from "styled-components";
import {Overlay, Tooltip} from "react-bootstrap";
import parse from "html-react-parser";
import Icon from "./Icon";
import {useMessages} from "../hooks/useMessages";
import {getTheme} from "../shared/themeUtils";

const TooltipContain = styled.div`
  display: inline-block;
  .children {
    padding-right: ${getTheme("space.1")};
    cursor: pointer;
    display: inline-block;
    .icon {
      display: inline-block;
      margin-left: ${getTheme("space.0")};
        position: relative;
        top: 3px;
    }
  }
`;

type TooltipProps = {
  content: string,
  linkUrl?: string,
  title?: string,
  placement: "right" | "left" | "top" | "bottom",
  className?: string,
  color?: string,
  /** Custom icon */
  customIcon?: string
  /** Click event */
  onClick?: () => void;
}

const CustomTooltip: React.FC<TooltipProps> = (props: TooltipProps) => {
  const [showOnClick, setShowOnClick] = useState(false);
  const [showOnHover, setShowOnHover] = useState(false);
  const target = useRef<HTMLDivElement | null>(null);
  const messagesQuery = useMessages()

  const handleOutsideClick = () => {
    setShowOnClick(false);
    setShowOnHover(false);
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowOnClick(!showOnClick);
    props.onClick && props.onClick();
  }

  return (
    <TooltipContain>
      <div
        ref={target}
        onClick={handleClick}
        onMouseEnter={() => setShowOnHover(true)}
        onMouseLeave={() => {
          if (!showOnClick) {
            setShowOnHover(false);
          }
        }}
        className={"children"}
      >
        {/*{props.children}*/}
        <Icon variant="xSmall" className="icon" color={props.color ? props.color : "secondary"}>
          {props.customIcon ? props.customIcon : "information-line"}
        </Icon>
      </div>

      <Overlay
        show={showOnClick || showOnHover}
        target={target.current}
        placement={props.placement}
        rootClose
        onHide={handleOutsideClick}
      >
        {(overlayProps) => (
          <Tooltip id="tooltip" {...overlayProps} className={"custom-tooltip"}>
            {props.title && <div className={"tooltip-title"}>{props.title}</div>}
            {parse(props.content)}
            {props.linkUrl && messagesQuery.data &&
              <div className={"tooltip-link"}>
                <a href={props.linkUrl}
                   target="_blank"  rel="noreferrer">
                  {messagesQuery.data.messages["see-more"]}
                </a>
              </div>
            }
          </Tooltip>
        )}
      </Overlay>
    </TooltipContain>
  )
}

export default CustomTooltip;
